import React, { useEffect, useState } from "react";
import { useLazyGetCmsQuery } from "../../services/cms";

const DeletePolicy = () => {
  const [getCms] = useLazyGetCmsQuery();
  const [terms, setTerms] = useState<string>("");

  const getCmsData = async () => {
    try {
      const response = await getCms({}).unwrap();
      if (response.statusCode === 200) {
        setTerms(response?.data?.terms);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <div className="delete-policy">
      <p dangerouslySetInnerHTML={{ __html: terms || "" }} />
    </div>
  );
};

export default DeletePolicy;
